import request, { requestPage } from 'ykd-base/request'
import Access from '@/model/common/ossAccess'

export async function queryRoleAccess(): Promise<Access> {
  const res = await request<Access>({
    method: 'POST',
    biz: 'bmatch',
    url: 'https://bmatch.youkeda.com/api/oss/uploadSTS'
  })
  return res.data
}

export async function oss() {
  const result = await request<any>({
    method: "POST",
    biz: "pizza",
    url: "/common/oss",
    data: {}
  });
  return result;
}

// export async function uploadFile(data) {
//   return request({
//     url: '/oss/uploadFile',
//     method: 'post',
//     data
//   })
// }
